import { useState, useEffect } from 'react';

import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';

import RefreshIcon from '@mui/icons-material/Refresh';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { Chart } from "react-google-charts";

const TeamInsightRG = ({ teamid, firstTeam, teamOptions }) => {

    const [cmpSrid, setCmpSrid] = useState('')

    const [teamAData, setTeamAData] = useState([])

    const [data, setData] = useState([])
    const [options, setOptions] = useState([])

    const [selectedColumn, setSelectedColumn] = useState(-1)
    const [selectedLabel, setSelectedLabel] = useState('')
    const [leaderboards, setLeaderboards] = useState([])

    const [cmpLeaderboards, setCmpLeaderboards] = useState([])

    const [anchorEl, setAnchorEl] = useState(null)

    const [selectedChart, setSelectedChart] = useState('bar')

    const [barData, setBarData] = useState([])
    const [barOptions, setBarOptions] = useState([])

    const [compareChart, setCompareChart] = useState([])
    const [compareChartOptions, setCompareChartOptions] = useState([])

    const [selectedOppTeamId, setSelectedOppTeamId] = useState(0)

    const [notes, setNotes] = useState([])

    /*const listEppa = ["PO", "RO", "PD", "RD", "ST"]*/
    const listEppa = ["PO", "RO", "PD", "RD"]

    const epaHeaders = [
        {
            name: "PO-PD",
            col_att: "PASS ATTEMPTS",
            col_epa: "EPA/ATTEMPT"
        },
        {
            name: "RO-RD",
            col_att: "RUSH ATTEMPTS",
            col_epa: "EPA/RUSH"
        },
        {
            name: "ST-LT",
            col_att: "PLAYS",
            col_epa: "EPA/PLAY"
        }
    ]

    const handleResize = () => {
        LoadLineChart()
    }

    useEffect(() => {

        //// Update jacksonville srid from jac to jax
        var foundIndex = teamOptions.findIndex(x => x.srid === "JAC");
        teamOptions[foundIndex].srid = "JAX";

        firstTeam.srid = firstTeam.srid === "JAC" ? "JAX" : firstTeam.srid

        LoadLineChart();

        //window.addEventListener('resize', handleResize)
        //return () => window.removeEventListener('resize', handleResize);

    }, []);

    const LoadLineChart = () => {

        setData([])

        loadData(teamid)
            .then(function (d) {
                
                setTeamAData(d.Epa)

                setLeaderboards(d.Leaderboards)
                setNotes(d.Notes)
                drawData(d.Epa)

            })
            .catch(function (e) {
                console.log(e)
            })

    }

    const loadData = async (tmId) => {

        return new Promise((resolve, reject) => {
            fetch(`/NFL/EPA?teamid=${tmId}`).then(response => {
                if (response.ok) {
                    resolve(response.json())
                } else {
                    reject(new Error('error'))
                }
            }, error => {
                reject(new Error(error.message))
            })
        })

    }

    const [selectedSeason, setSelectedSeason] = useState("2024");

    // Add these state declarations
    const [selectedTmName, setSelectedTmName] = useState("");
    const [selectedColor1, setSelectedColor1] = useState("");
    const [selectedColor2, setSelectedColor2] = useState("");

    const onTeamChange = (event) => {
        const tmValue = event.target.value;
        const tmName = event.target.selectedOptions[0].getAttribute('tmName');
        const cmpColor1 = event.target.selectedOptions[0].getAttribute('color1');
        const cmpColor2 = event.target.selectedOptions[0].getAttribute('color2');

        // Update all states
        setCmpSrid(event.target.selectedOptions[0].getAttribute('srid'));
        setSelectedTmName(tmName);
        setSelectedColor1(cmpColor1);
        setSelectedColor2(cmpColor2);
        setCompareChart([]);
        setSelectedOppTeamId(tmValue);
        
        TmCompChart(tmValue, selectedSeason, tmName, cmpColor1, cmpColor2);
    };

    const onSeasonChange = (e) => {

        const _season = Number(e.target.value);

        setSelectedSeason(e.target.value);
        
        LoadLineChart();
    };

    const drawData = (epa) => {
        
        /////// Line Chart

        let eppArr = []

        eppArr.push(

            { name: "PO", value: epa?.PO, yAxis: 1, order: 0 },
            { name: "RO", value: epa?.RO, yAxis: 1, order: 1 },
            { name: "PD", value: epa?.PD, yAxis: 1, order: 2 },
            { name: "RD", value: epa?.RD, yAxis: 1, order: 3 },
            { name: "ST", value: epa?.ST, yAxis: 1, order: 4 },
            { name: "LT", value: epa?.LT, yAxis: 1, order: 5 },
        )

        eppArr.sort((a, b) => a.value - b.value)

        let next

        let prev

        let curr

        let diff

        let yEppa = 1

        for (let x = 0; x <= eppArr.length - 1; x++) {

            if (eppArr.length - 1 !== x) {

                next = eppArr[x + 1].value

                curr = eppArr[x].value

                diff = Math.abs(curr - next)

                if (diff <= 5) {
                    yEppa += 2
                    eppArr[x + 1].yAxis = yEppa
                }
                else {
                    yEppa = 1
                }

            }
            //else {
            //    prev = eppArr[x - 1].value
            //    curr = eppArr[x].value
            //    diff = Math.abs(curr - prev) 

            //    if (diff <= 6) {
            //        yEppa += 2
            //        eppArr[x + 1].yAxis = yEppa
            //    }
            //    else {
            //        yEppa = 1
            //    }

            //}

        }

        eppArr.sort((a, b) => a.order - b.order)

        const d = [
            [
                { label: "vale", type: "number" }, { label: "vale", type: "number" }, { role: "annotation", type: "string" }
            ],
            [eppArr[0].value, eppArr[0].yAxis, eppArr[0].name],
            [eppArr[1].value, eppArr[1].yAxis, eppArr[1].name],
            [eppArr[2].value, eppArr[2].yAxis, eppArr[2].name],
            [eppArr[3].value, eppArr[3].yAxis, eppArr[3].name],
            [eppArr[4].value, eppArr[4].yAxis, eppArr[4].name],
            [eppArr[5].value, eppArr[5].yAxis, eppArr[5].name]
        ]

        const o = {

            series: {
                0: { tooltip: false }, // disable tooltip

            },
            annotations: {
                stem: {
                    length: -5
                },
                textStyle: {

                    fontSize: 10,
                    bold: true,
                    // The color of the text.
                    color: 'white',
                    // The color of the text outline.
                    auraColor: 'transparent',
                    // The transparency of the text.
                    opacity: 1
                }
            },
            dataLoadingStatus: 'ready',
            hAxis: {
                /*ticks: [0, 25, 50, 75, 100],*/
                ticks: [
                    { v: 0, f: '0\nWorst' },
                    { v: 25, f: '25' },
                    { v: 50, f: '50\nMiddle of the Pack' },
                    { v: 75, f: '75' },
                    { v: 100, f: '100\nBest' }
                ],
                textPosition: 'out',
                textStyle: {
                    fontName: 'Arial',
                    fontSize: '12'
                },

            },
            vAxis: {
                textPosition: 'none',
                title: firstTeam.name,

                lineWidth: 5,
                textStyle: {
                    fontName: 'Arial',
                    fontSize: '24'
                },
                minValue: 2, maxValue: 8
            },
            legend: 'none',
            colors: ['black'],
            pointSize: 20,
            /*width: 500,*/
            chartArea: { width: '90%' },
        };

        setData(d)
        setOptions(o)

        //// BarChart
        const bd = [
            [{ 'type': 'string' }, { 'type': 'number' }, { role: 'annotation' }, { role: 'style' }],
            ["Passing Offense", epa?.PO, epa?.PO, `stroke-width: 2;stroke-color: ${firstTeam.color2}`],
            ["Rushing Offense", epa?.RO, epa?.RO, `stroke-width: 2;stroke-color: ${firstTeam.color2}`],
            ["Passing Defense", epa?.PD, epa?.PD, `stroke-width: 2;stroke-color: ${firstTeam.color2}`],
            ["Rushing Defense", epa?.RD, epa?.RD, `stroke-width: 2;stroke-color: ${firstTeam.color2}`],
            //["Special Teams", epa?.ST, epa?.ST, `stroke-width: 2;stroke-color: ${firstTeam.color2}`],
            /*["Little Things", epa?.LT, epa?.LT, `stroke-width: 2;stroke-color: ${firstTeam.color2}`],*/
        ];

        const bdo = {
            chartArea: { width: '90%' },
            colors: [firstTeam.color1],
            bar: { groupWidth: "35%" },
            // Add this annotations configuration
            annotations: {
                textStyle: {
                    fontSize: 12,
                    bold: true,
                    color: 'black'
                },
                stem: {
                    color: 'transparent'
                },
                // Remove alwaysOutside: true
            },
            vAxis: {
                lineWidth: 5,
                textStyle: {
                    fontName: 'Arial',
                    fontSize: '16'
                },
                // Add this to push more space for labels
                viewWindow: {
                    min: 0,
                    max: 105 // Increase to give more headroom for labels
                }
            },
            legend: 'none',
        };

        const bdoX = {

            chartArea: { width: '90%' },
            colors: [firstTeam.color1],
            bar: { groupWidth: "35%" },

            // Add this annotations configuration
            annotations: {
                textStyle: {
                    fontSize: 12,
                    bold: true,
                    color: 'black'
                },
                stem: {
                    color: 'transparent'
                },
                alwaysOutside: true // Force annotations to always appear outside
            },

            vAxis: {
                lineWidth: 5,
                textStyle: {
                    fontName: 'Arial',
                    fontSize: '16'
                }
            },
            legend: 'none',
        };
        setBarOptions(bdo)
        console.log("BDD", bd)
        setBarData(bd)

    }

    const TmCompChart = (tmId, season, oppTeam, cmpColor1, cmpColor2) => {

        loadData(tmId, season)
            .then(function (d) {

                const oppData = d.Epa
                const epa = teamAData

                

                setCmpLeaderboards(d.Leaderboards)
                //firstTeam.color1
                //cmpColor1
                const comboData = [
                    [
                        { 'type': 'string' }, { 'type': 'number', label: firstTeam?.name }, { role: 'annotation' }, { role: 'style' },
                        { 'type': 'number', label: oppTeam }, { role: 'annotation' }, { role: 'style' }
                    ],
                    ["Passing Offense", epa?.PO, epa?.PO, `stroke-width: 2;stroke-color: ${firstTeam?.color2}`, oppData?.PO, oppData?.PO, `stroke-width: 2;stroke-color: ${cmpColor2}`],
                    ["Rushing Offense", epa?.RO, epa?.RO, `stroke-width: 2;stroke-color: ${firstTeam?.color2}`, oppData?.RO, oppData?.RO, `stroke-width: 2;stroke-color: ${cmpColor2}`],
                    ["Passing Defense", epa?.PD, epa?.PD, `stroke-width: 2;stroke-color: ${firstTeam?.color2}`, oppData?.PD, oppData?.PD, `stroke-width: 2;stroke-color: ${cmpColor2}`],
                    ["Rushing Defense", epa?.RD, epa?.RD, `stroke-width: 2;stroke-color: ${firstTeam?.color2}`, oppData?.RD, oppData?.RD, `stroke-width: 2;stroke-color: ${cmpColor2}`],
                    //["Special Teams", epa?.ST, epa?.ST, `stroke-width: 2;stroke-color: ${firstTeam.color2}`, oppData.ST, oppData.ST, `stroke-width: 2;stroke-color: ${cmpColor2}`],
                    /*["Little Things", epa?.LT, epa?.LT, `stroke-width: 2;stroke-color: ${firstTeam.color2}`, oppData.LT, oppData.LT, `stroke-width: 2;stroke-color: ${cmpColor2}`],*/
                ];

                const comboDataOptions = {
                    colors: [firstTeam.color1, cmpColor1],
                    chartArea: {
                        width: '90%'
                    },
                    bar: { groupWidth: "70%" },
                    legend: { position: 'bottom' },
                    vAxis: {

                        lineWidth: 5,
                        textStyle: {
                            fontName: 'Arial',
                            fontSize: '16'
                        }
                    },


                };

                setCompareChart(comboData)
                setCompareChartOptions(comboDataOptions)

            })
            .catch(function (e) {
                console.log(e)
            })

    }

    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const chartEvents = [
        {
            eventName: "ready",
            callback: ({ chartWrapper, google }) => {
                const chart = chartWrapper.getChart();

                google.visualization.events.addListener(chart, 'select', e => {

                    var selectedItem = chart.getSelection()[0];

                    if (selectedItem) {

                        setSelectedColumn(selectedItem.column)

                        setSelectedLabel(listEppa[selectedItem.row])

                        handleClick(chart.container)

                    }
                });
            }
        }
    ];

    const FilterEpa = () => {
        //// 1 = main team /// 3 = compare to team
        const lboards = selectedColumn === 1 || selectedColumn === 2 ? leaderboards : cmpLeaderboards

        var dataLeaderboards = lboards?.filter(x => x.Label === selectedLabel).sort((a, b) => a.Rank - b.Rank)

        return RankColorShades(dataLeaderboards)

    }

    const RankColorShades = (model) => {

        let cRed = "#f8696b"
        let cBlue = '#5a8ac6'

        const ColorShading = (d, col) => {

            let amt = 9

            var usePound = false;

            if (col[0] == "#") {
                col = col.slice(1);
                usePound = true;
            }

            d.forEach((val, idx) => {

                val.RO = 2;
                val.PO = 2;
                val.RD = 2;
                val.RD = 2;
                val.LT = 2;
                val.ST = 2;

                if (idx === 0) {
                    val.BackgroundColor = `#${col}`
                }
                else {
                    var R = parseInt(col.substring(0, 2), 16);
                    var G = parseInt(col.substring(2, 4), 16);
                    var B = parseInt(col.substring(4, 6), 16);

                    R = R + amt;
                    G = G + amt;
                    B = B + amt;

                    if (R > 255) R = 255;
                    else if (R < 0) R = 0;

                    if (G > 255) G = 255;
                    else if (G < 0) G = 0;

                    if (B > 255) B = 255;
                    else if (B < 0) B = 0;

                    let RR = ((R.toString(16).length == 1) ? "0" + R.toString(16) : R.toString(16));
                    let GG = ((G.toString(16).length == 1) ? "0" + G.toString(16) : G.toString(16));
                    let BB = ((B.toString(16).length == 1) ? "0" + B.toString(16) : B.toString(16));

                    val.BackgroundColor = "#" + RR + GG + BB;

                    col = RR + GG + BB;
                }

            });

        }

        ///// red 1-16        
        ColorShading(model.slice(0, 16).sort((a, b) => a.Rank - b.Rank), cRed)

        ///// blue 17-32
        ColorShading(model.slice(16, 32).sort((b, a) => a.Rank - b.Rank), cBlue)

        //// sort to original
        return model.sort((a, b) => a.Rank - b.Rank)

    }

    if (data.length === 0) {

        return (
            <div className="w-100 text-center p-5">
                <Box>
                    <CircularProgress />
                </Box>
            </div>
        )

    }

    return (
        <>
            <Container className="p-0">
                <Row id="legendChart" style={{ fontSize: "14px" }}>
                    <Col lg={12} className="text-center mb-4 d-none">
                        <button
                            onClick={() => setSelectedChart('line')}
                            className={`btn btn-sm btn-outline-dark me-1 ${selectedChart === 'line' ? 'active' : ''}`}
                        >
                            Line Chart
                        </button>
                        <button
                            onClick={() => setSelectedChart('bar')}
                            className={`btn btn-sm btn-outline-dark me-1 ${selectedChart === 'bar' ? 'active' : ''}`}
                        >
                            Bar Chart
                        </button>

                        <button
                            onClick={() => LoadLineChart()}
                            className="btn btn-sm btn-light float-end"
                        >
                            <RefreshIcon />
                        </button>

                    </Col>

                    {
                        selectedChart === "bar"
                            ?
                            <div className="px-0 col-12 pb-3">
                                <div className="row">
                                    <div className="d-none col-6">
                                        <span>Season: </span>
                                        <select
                                            id="seasonDropDown"
                                            onChange={(e) => onSeasonChange(e)}
                                            value={selectedSeason}
                                            aria-label="Select season"
                                            className="form-select form-select-sm d-inline"
                                        >
                                            <option value="2024">2024</option>
                                            <option value="2023">2023</option>
                                        </select>
                                    </div>
                                    <div className="col-6">
                                        <span>Compare Team: </span>
                                        <select
                                            id="compDropDown"
                                            onChange={(e) => onTeamChange(e)}
                                            value={selectedOppTeamId}
                                            aria-label="Default select"
                                            className="form-select form-select-sm d-inline"
                                        >
                                            <option value="0">Select Team</option>
                                            {teamOptions.map((i, index) => (
                                                <option
                                                    key={i.value}
                                                    value={i.value}
                                                    srid={i.srid}
                                                    tmname={i.tmName}
                                                    color1={i.color1}
                                                    color2={i.color2}
                                                >
                                                    {i.text}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            : <></>

                    }

                    <Col lg={4}><b>RO</b> = Rushing OFFENSE</Col>
                    <Col lg={4}><b>RD</b> = Rushing DEFFENSE</Col>
                    {/*<Col lg={4}><b>ST</b> = Special Teams</Col>*/}
                    <Col lg={4}><b>PO</b> = Passing OFFENSE</Col>
                    <Col lg={4}><b>PD</b> = Passing DEFFENSE</Col>
                    {/*<Col lg={4}><b>LT</b> = Little Things</Col>*/}
                </Row>

                {
                    data?.length !== 0 && selectedChart === "line"
                        ?
                        <>
                            <Chart
                                className="w-100"
                                chartType="ScatterChart"
                                data={data}
                                options={options}
                                chartEvents={chartEvents}

                            />

                        </>
                        :
                        <div>

                            {
                                Number(selectedOppTeamId) === teamid || Number(selectedOppTeamId) === 0
                                    ?
                                    barData.length !== 0
                                        ?
                                        <Chart
                                            chartType="ColumnChart"
                                            width="100%"
                                            height="300px"
                                            data={barData}
                                            options={barOptions}
                                            chartEvents={chartEvents}
                                        />
                                        :
                                        <div className="w-100 text-center p-5">
                                            <Box>
                                                <CircularProgress />
                                            </Box>

                                        </div>
                                    :
                                    compareChart.length !== 0
                                        ?
                                        <>
                                            <Chart
                                                className="p-0"
                                                chartType="ColumnChart"
                                                width="100%"
                                                height="300px"
                                                data={compareChart}
                                                options={compareChartOptions}
                                                chartEvents={chartEvents}
                                            />
                                        </>
                                        :
                                        <div className="w-100 text-center p-5">
                                            <Box>
                                                <CircularProgress />
                                            </Box>
                                        </div>
                            }


                        </div>

                }
                <div className="w-100 bg-light p-2 text-sm fst-italic text-center">Average EPA per play expressed as percentiles where 100 is best in league</div>
                <div className="card my-4 border-0">

                    <div className="card-header border-1">
                        Team Insights (powered by Remarkable)
                    </div>

                    <div className="card-body px-0">
                        <ul id="epa_notes">

                            {
                                notes?.map((item, idx) => {

                                    return (
                                        <li className="my-2" key={`note_${idx}`} dangerouslySetInnerHTML={{ __html: item.note }} />
                                    )

                                })
                            }

                        </ul>
                    </div>

                </div>

            </Container>

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{
                    style: { height: '50%' },
                }}
            >
                <Typography sx={{ p: 2 }}>
                    <table className="pnlLeaderboards table table-lg text-center">

                        <caption
                            className='pnlClose p-0'
                            style={{ captionSide: "top", fontWeight: "bold", padding: "0px 10px" }}
                            onClick={() => handleClose()}
                        >
                            <div className="row">
                                <div className="col text-center text-secondary border">{selectedLabel}</div>
                                <div className="col text-end">X</div>
                            </div>

                        </caption>
                        <thead>

                            {
                                epaHeaders.filter(x => x.name.includes(selectedLabel)).map(e => {

                                    return (
                                        <tr key={e.name}>
                                            <th>RANK</th>
                                            <th>TEAM</th>
                                            <th>{e.col_epa}</th>
                                        </tr>
                                    )

                                })
                            }
                        </thead>
                        <tbody>
                            {
                                FilterEpa()?.map((d, i) => {

                                    return (

                                        <tr
                                            key={d.TeamName}
                                            style={d.TeamName === (selectedColumn === 1 || selectedColumn === 2 ? firstTeam.srid : cmpSrid) ? { backgroundColor: '#ffff99', border: '2px solid #C8C8C8' } : {}}
                                        >
                                            <td>{d.Rank}</td>
                                            <td>{d.TeamName}</td>
                                            <td
                                                style={{ backgroundColor: d.BackgroundColor }}
                                            >
                                                {d.Value.toFixed(3)}
                                            </td>
                                        </tr>

                                    )

                                })
                            }
                            <tr className="text-center">
                                <td colSpan="4" className="border-0">
                                    <button
                                        onClick={() => handleClose()}
                                        className='btn pnlClose p-2 border-0'
                                    >
                                        Close
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Typography>
            </Popover>

        </>
    )

}

export default TeamInsightRG